import SineIcon from "../../../shared-assets/icons/dataflow/generator/sine.svg";
import SquareIcon from "../../../shared-assets/icons/dataflow/generator/square.svg";
import TriangleIcon from "../../../shared-assets/icons/dataflow/generator/triangle.svg";
import AndIcon from "../../../shared-assets/icons/dataflow/logic/and.svg";
import EqualIcon from "../../../shared-assets/icons/dataflow/logic/equal.svg";
import GreaterThanOrEqualToIcon from "../../../shared-assets/icons/dataflow/logic/greater-than-or-equal-to.svg";
import GreaterThanIcon from "../../../shared-assets/icons/dataflow/logic/greater-than.svg";
import LessThanOrEqualToIcon from "../../../shared-assets/icons/dataflow/logic/less-than-or-equal-to.svg";
import LessThanIcon from "../../../shared-assets/icons/dataflow/logic/less-than.svg";
import NandIcon from "../../../shared-assets/icons/dataflow/logic/nand.svg";
import NotEqualIcon from "../../../shared-assets/icons/dataflow/logic/not-equal.svg";
import OrIcon from "../../../shared-assets/icons/dataflow/logic/or.svg";
import XorIcon from "../../../shared-assets/icons/dataflow/logic/xor.svg";
import AddIcon from "../../../shared-assets/icons/dataflow/math/add.svg";
import SubtractIcon from "../../../shared-assets/icons/dataflow/math/subtract.svg";
import MultiplyIcon from "../../../shared-assets/icons/dataflow/math/multiply.svg";
import DivideIcon from "../../../shared-assets/icons/dataflow/math/divide.svg";
import LightBulbIcon from "../../../shared-assets/icons/dataflow/output/light-bulb.svg";
import GrabberIcon from "../../../shared-assets/icons/dataflow/output/grabber.svg";
import AdvancedGrabberIcon from "../../assets/icons/output/advanced-grabber.svg";
import HumidIcon from "../../../shared-assets/icons/dataflow/output/humid.svg";
import FanIcon from "../../../shared-assets/icons/dataflow/output/fan.svg";
import TemperatureIcon from "../../../shared-assets/icons/dataflow/sensor/temperature.svg";
import CO2Icon from "../../../shared-assets/icons/dataflow/sensor/co2.svg";
import HumidityIcon from "../../../shared-assets/icons/dataflow/sensor/humidity.svg";
import LightIcon from "../../../shared-assets/icons/dataflow/sensor/light.svg";
import SignalIcon from "../../../shared-assets/icons/dataflow/control/signal.svg";
import EMGIcon from "../../../shared-assets/icons/dataflow/sensor/sensor-emg-icon.svg";
import PressureIcon from "../../../shared-assets/icons/dataflow/sensor/pressure.svg";
import ServoIcon from "../../../shared-assets/icons/dataflow/output/servo.svg";
import AbsoluteValueIcon from "../../../shared-assets/icons/dataflow/transform/absolute-value.svg";
import NegationIcon from "../../../shared-assets/icons/dataflow/transform/negation.svg";
import NotIcon from "../../../shared-assets/icons/dataflow/transform/not.svg";
import HoldPreviousArrowIcon from "../../assets/icons/control/hold-previous.svg";
import HoldCurrentArrowIcon from "../../assets/icons/control/hold-this.svg";
import HoldZeroArrowIcon from "../../assets/icons/control/hold-zero.svg";
import { isFiniteNumber } from "../../../../utilities/math-utils";
export const kMaxNodeValues = 16;
export const NodeTypes = [
    {
        name: "Sensor",
        displayName: "Input",
    },
    {
        name: "Number",
        displayName: "Number",
    },
    {
        name: "Generator",
        displayName: "Generator",
    },
    {
        name: "Timer",
        displayName: "Timer (on/off)"
    },
    {
        name: "Math",
        displayName: "Math",
    },
    {
        name: "Logic",
        displayName: "Logic",
    },
    {
        name: "Transform",
        displayName: "Transform",
    },
    {
        name: "Control",
        displayName: "Hold",
    },
    {
        name: "Demo Output",
        displayName: "Demo Output",
    },
    {
        name: "Live Output",
        displayName: "Live Output",
    }
];
export const NodeOperationTypes = [
    {
        name: "Add",
        type: "math",
        method: (n1, n2) => n1 + n2,
        numberSentence: (n1, n2) => `${n1} + ${n2} = `,
        icon: AddIcon
    },
    {
        name: "Subtract",
        type: "math",
        method: (n1, n2) => n1 - n2,
        numberSentence: (n1, n2) => `${n1} - ${n2} = `,
        icon: SubtractIcon
    },
    {
        name: "Multiply",
        type: "math",
        method: (n1, n2) => n1 * n2,
        numberSentence: (n1, n2) => `${n1} * ${n2} = `,
        icon: MultiplyIcon
    },
    {
        name: "Divide",
        type: "math",
        method: (n1, n2) => n1 / n2,
        numberSentence: (n1, n2) => `${n1} / ${n2} = `,
        icon: DivideIcon
    },
    {
        name: "Absolute Value",
        type: "transform",
        method: (n1, n2) => Math.abs(n1),
        numberSentence: (n1, n2) => `|${n1}| = `,
        icon: AbsoluteValueIcon
    },
    {
        name: "Negation",
        type: "transform",
        method: (n1, n2) => 0 - n1,
        numberSentence: (n1, n2) => `-(${n1}) = `,
        icon: NegationIcon
    },
    {
        name: "Not",
        type: "transform",
        method: (n1, n2) => n1 ? 0 : 1,
        numberSentence: (n1, n2) => `!${n1} ⇒ `,
        icon: NotIcon
    },
    {
        name: "Round",
        type: "transform",
        method: (n1, n2) => Math.round(n1),
        numberSentence: (n1, n2) => `round(${n1}) = `,
        icon: SignalIcon
    },
    {
        name: "Floor",
        type: "transform",
        method: (n1, n2) => Math.floor(n1),
        numberSentence: (n1, n2) => `floor(${n1}) = `,
        icon: SignalIcon
    },
    {
        name: "Ceil",
        type: "transform",
        method: (n1, n2) => Math.ceil(n1),
        numberSentence: (n1, n2) => `ceil(${n1}) = `,
        icon: SignalIcon
    },
    {
        name: "Ramp",
        type: "transform",
        method: (n1, n2, prevValue) => {
            if (!isFiniteNumber(prevValue))
                return n1;
            const delta = n1 - prevValue;
            const isSteep = Math.abs(delta) > 0.1 * prevValue;
            if (delta > 0) {
                const increaseBy = n1 * 0.1;
                return isSteep ? prevValue + increaseBy : n1;
            }
            if (delta < 0) {
                const decreaseBy = prevValue * 0.1;
                return isSteep ? prevValue - decreaseBy : n1;
            }
            return n1;
        },
        numberSentence: (n1, n2) => `${n1} → `,
        icon: SignalIcon
    },
    {
        name: "Greater Than",
        type: "logic",
        method: (n1, n2) => +(n1 > n2),
        numberSentence: (n1, n2) => `${n1} > ${n2} ⇒ `,
        icon: GreaterThanIcon
    },
    {
        name: "Less Than",
        type: "logic",
        method: (n1, n2) => +(n1 < n2),
        numberSentence: (n1, n2) => `${n1} < ${n2} ⇒ `,
        icon: LessThanIcon
    },
    {
        name: "Greater Than Or Equal To",
        type: "logic",
        method: (n1, n2) => +(n1 >= n2),
        numberSentence: (n1, n2) => `${n1} >= ${n2} ⇒ `,
        icon: GreaterThanOrEqualToIcon
    },
    {
        name: "Less Than Or Equal To",
        type: "logic",
        method: (n1, n2) => +(n1 <= n2),
        numberSentence: (n1, n2) => `${n1} <= ${n2} ⇒ `,
        icon: LessThanOrEqualToIcon
    },
    {
        name: "Equal",
        type: "logic",
        method: (n1, n2) => +(n1 === n2),
        numberSentence: (n1, n2) => `${n1} == ${n2} ⇒ `,
        icon: EqualIcon
    },
    {
        name: "Not Equal",
        type: "logic",
        method: (n1, n2) => +(n1 !== n2),
        numberSentence: (n1, n2) => `${n1} != ${n2} ⇒ `,
        icon: NotEqualIcon
    },
    {
        name: "And",
        type: "logic",
        method: (n1, n2) => n1 && n2 ? 1 : 0,
        numberSentence: (n1, n2) => `${n1} && ${n2} ⇒ `,
        icon: AndIcon
    },
    {
        name: "Or",
        type: "logic",
        method: (n1, n2) => n1 || n2 ? 1 : 0,
        numberSentence: (n1, n2) => `${n1} || ${n2} ⇒ `,
        icon: OrIcon
    },
    {
        name: "Nand",
        type: "logic",
        method: (n1, n2) => +(!(n1 && n2 ? 1 : 0)),
        numberSentence: (n1, n2) => `${n1} nand ${n2} ⇒ `,
        icon: NandIcon
    },
    {
        name: "Xor",
        type: "logic",
        method: (n1, n2) => +((n1 ? 1 : 0) !== (n2 ? 1 : 0)),
        numberSentence: (n1, n2) => `${n1} xor ${n2} ⇒ `,
        icon: XorIcon
    }
];
export const HoldFunctionOptions = [
    {
        name: "Hold Current",
        displayName: "Hold this",
        type: "control",
        icon: HoldCurrentArrowIcon
    },
    {
        name: "Hold Prior",
        displayName: "Hold previous",
        type: "control",
        icon: HoldPreviousArrowIcon
    },
    {
        name: "Output Zero",
        displayName: "Hold 0",
        type: "control",
        icon: HoldZeroArrowIcon
    },
    // {
    //   name: "Hold Current Wait",
    //   displayName: "Hold this, wait",
    //   type: "control",
    //   icon: HoldCurrentArrowIcon
    // },
    // {
    //   name: "Hold Prior Wait",
    //   displayName: "Hold previous, wait",
    //   type: "control",
    //   icon: HoldPreviousArrowIcon
    // },
    // {
    //   name: "Output Zero Wait",
    //   displayName: "Hold 0, wait",
    //   type: "control",
    //   icon: HoldZeroArrowIcon
    // }
];
export const NodeSensorTypes = [
    {
        name: "Temperature",
        type: "temperature",
        units: "°C",
        icon: TemperatureIcon
    },
    {
        name: "Humidity",
        type: "humidity",
        units: "%",
        icon: HumidityIcon
    },
    {
        name: "CO₂",
        type: "CO2",
        units: "PPM",
        icon: CO2Icon
    },
    {
        name: "Light",
        type: "light",
        units: "lux",
        icon: LightIcon
    },
    // {
    //   name: "O₂",
    //   type: "O2",
    //   units: "%",
    //   icon: O2Icon
    // },
    // {
    //   name: "Soil Moisture",
    //   type: "soil-moisture",
    //   units: "",
    //   icon: MoistureIcon
    // },
    // {
    //   name: "Particulates",
    //   type: "particulates",
    //   units: "PM2.5",
    //   icon: ParticulatesIcon
    // },
    {
        name: "EMG",
        type: "emg-reading",
        units: "mV",
        icon: EMGIcon,
        decimalPlaces: 0
    },
    {
        name: "Surface Pressure",
        type: "fsr-reading",
        units: "psi",
        icon: PressureIcon,
        decimalPlaces: 0
    },
    {
        name: "Pin Reading",
        type: "pin-reading",
        units: "mV",
        icon: SignalIcon,
        decimalPlaces: 0
    }
];
export const NodeDemoOutputTypes = [
    {
        name: "Light Bulb",
        icon: LightBulbIcon
    },
    {
        name: "Grabber",
        icon: GrabberIcon,
        displayName: "Gripper"
    },
    {
        name: "Advanced Grabber",
        icon: AdvancedGrabberIcon,
        displayName: "Advanced Gripper"
    },
    {
        name: "Fan",
        icon: FanIcon
    },
    {
        name: "Humidifier",
        icon: HumidIcon
    }
];
export const NodeLiveOutputTypes = [
    {
        name: "Gripper 2.0",
        icon: GrabberIcon,
        angleBase: 130,
        sweep: 95
    },
    {
        name: "Grabber",
        icon: GrabberIcon,
        angleBase: 180,
        sweep: 60,
        displayName: "Gripper"
    },
    {
        name: "Humidifier",
        icon: HumidIcon,
        relayIndex: 2
    },
    {
        name: "Fan",
        icon: FanIcon,
        relayIndex: 1
    },
    {
        name: "Heat Lamp",
        icon: LightBulbIcon,
        relayIndex: 0
    },
    {
        name: "Servo",
        icon: ServoIcon,
        angleBase: 0,
        angleOffset: 30,
        angleScale: 2 / 3,
        sweep: 180
    }
];
function createNodeMicroBitHubs(arr) {
    return arr.map((id) => {
        return {
            id,
            name: `micro:bit hub ${id}`,
            active: false
        };
    });
}
const hubIdentifiers = ["a", "b", "c", "d", "e", "f", "g", "h"];
export const NodeMicroBitHubs = createNodeMicroBitHubs(hubIdentifiers);
export const NodeGeneratorTypes = [
    {
        name: "Sine",
        method: (t, p, a) => Math.round(Math.sin(t * Math.PI / (p / 2)) * a * 100) / 100,
        icon: SineIcon
    },
    {
        name: "Square",
        method: (t, p, a) => t % p < p / 2 ? 1 * a : 0,
        icon: SquareIcon
    },
    {
        name: "Triangle",
        method: (t, p, a) => (2 * a / p) * Math.abs(t % p - p / 2),
        icon: TriangleIcon
    }
];
export const baseLiveOutputOptions = {
    liveGripperOption: {
        active: true,
        icon: GrabberIcon,
        id: "bb-gripper",
        name: "Physical Gripper"
    },
    noDeviceLiveGripperOption: {
        active: true,
        id: "no-device-bb-gripper",
        name: "Physical Gripper",
        displayName: "⚠️ connect device",
    },
    liveServoOption: {
        active: true,
        icon: ServoIcon,
        id: "bb-servo",
        name: "Physical Servo"
    },
    noDeviceliveServoOption: {
        active: true,
        id: "no-devie-bb-servo",
        name: "Physical Servo",
        displayName: "⚠️ connect device",
    },
    genericWarningOption: {
        active: true,
        id: "no-outputs-found",
        name: "⚠️ connect device",
    }
};
export const NodePeriodUnits = [
    {
        unit: "sec",
        lengthInSeconds: 1
    },
    {
        unit: "min",
        lengthInSeconds: 60
    },
    {
        unit: "hour",
        lengthInSeconds: 3600
    },
];
export const NodeTimerInfo = {
    method: (t, tOn, tOff) => t % (tOn + tOff) < tOn ? 1 : 0,
};
export const ChartPlotColors = ["#d51eff", "#17ddd7", "#d3d114", "#3974ff", "#ff3d3d",
    "#49d381", "#b05ecb", "#ffd56d", "#ffa56d", "#f57676",
    "#fa73b0", "#eb80dc", "#cd88e4", "#d49600", "#d45200",
    "#c60e0e", "#cc0860", "#b81da1", "#8d27ad", "#8b989f",
    "#5dd581", "#3cc8f5", "#aeb9bf", "#92e3aa", "#7ad9f8",
    "#5d6e77", "#31bc5a", "#0caadd"];
export const NodePlotColor = "#3f3f3f";
export const NodePlotBlue = ChartPlotColors[3];
export const NodePlotRed = ChartPlotColors[4];
export const DEFAULT_DATA_RATE = 1000;
export const ProgramDataRates = [
    {
        text: "50ms",
        val: 50
    },
    {
        text: "100ms",
        val: 100
    },
    {
        text: "500ms",
        val: 500
    },
    {
        text: "1 sec",
        val: 1000
    },
    {
        text: "10 sec",
        val: 10000
    },
    {
        text: "1 min",
        val: 60000
    }
];
export const kSensorSelectMessage = "Select an input";
export const kSensorMissingMessage = "⚠️";
export const kAnimatedBinaryTypes = ["Fan", "Humidifier"];
export const kMicroBitHubRelaysIndexed = ["Heat Lamp", "Fan", "Humidifier"];
export const kBinaryOutputTypes = [...kMicroBitHubRelaysIndexed, "Light Bulb"];
export const kGripperOutputTypes = ["Grabber", "Gripper", "Gripper 2.0"];
export const kServoOutputTypes = ["Servo"];
//# sourceMappingURL=data:application/json;base64,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